import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  titles: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Activar notificaciones de WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]: 'Llamadas automáticas sobre pedidos pendientes',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Horario de apertura',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Ubicación',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identidad del restaurante',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Tiempo de recogida',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Tiempo de entrega',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Credenciales del personal',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importar menú',
    [ONBOARDING_GUIDE_STEPS.Favourites]: 'Favoritos',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Artículos agotados',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Códigos promocionales',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galería',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]: 'Añadir logo y color principal del restaurante',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Pedir flyers',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Crear tienda',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Activar pedidos en vivo',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Activar Google Business',
  },
  descriptions: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Comprobar si el propietario/contacto tiene WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]:
      'Comprobar que el número del restaurante es correcto para recibir llamadas automáticas y no perder pedidos',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Configurar horarios de apertura del restaurante',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Configurar la ubicación del restaurante',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Define el tipo de restaurante y las cocinas que se muestran en la tienda',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Configurar los ajustes de tiempo de recogida',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Configurar los ajustes de tiempo de entrega',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Configurar las credenciales del personal',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importar menú de un proveedor externo',
    [ONBOARDING_GUIDE_STEPS.Favourites]:
      'Marca 4 artículos como favoritos. Pregunta al restaurante cuáles son los 4 platos más populares',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Configurar el comportamiento de artículos agotados',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Configurar códigos promocionales',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Actualizar galería',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]:
      'Obtén el logo del restaurante o de su página en Lieferando y guárdalo desde allí. Elige el color que más predomina en el logo del restaurante',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Editar el diseño del flyer y crear pedido',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Crear la tienda y editar el sitio web si es necesario',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Activar pedidos en vivo («¡solo en la fecha de lanzamiento!»)',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Conectar la cuenta de Google Business',
  },
  buttons: {
    mark_as_complete: 'Marcar como completado',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
  },
};
